const RTB_URL = '/rtb';

export function rtbApi(): string {
  return RTB_URL;
}

export function rtbCountries(rtbDest?: string): string {
  if (rtbDest) {
    return `${rtbApi()}/countries/${rtbDest}`;
  }

  return `${rtbApi()}/countries`;
}

export function allCountriesStatistic(): string {
  return `${rtbApi()}/countries-all-stat`;
}

export function rtbSummary(): string {
  return `${rtbApi()}/summary`;
}

export function rtbList(): string {
  return `${rtbApi()}/list`;
}
